import AuthenticationPage from './container';

export default AuthenticationPage;
